/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerReadQueryResponse, BidSubmissionsControllerReadPathParams, BidSubmissionsControllerReadQueryParams, BidSubmissionsControllerRead400, BidSubmissionsControllerRead401, BidSubmissionsControllerRead403, BidSubmissionsControllerRead404 } from "../../models/bidsController/BidSubmissionsControllerRead";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { bidSubmissionsControllerRead } from "../../clients/bidsService/bidSubmissionsControllerRead";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const bidSubmissionsControllerReadQueryKey = (id: BidSubmissionsControllerReadPathParams["id"], params: BidSubmissionsControllerReadQueryParams = {}) => [{
  url: '/api/v1/bid-submissions/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type BidSubmissionsControllerReadQueryKey = ReturnType<typeof bidSubmissionsControllerReadQueryKey>;
export function bidSubmissionsControllerReadQueryOptions(id: BidSubmissionsControllerReadPathParams["id"], params?: BidSubmissionsControllerReadQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = bidSubmissionsControllerReadQueryKey(id, params);
  return queryOptions<BidSubmissionsControllerReadQueryResponse, ResponseErrorConfig<BidSubmissionsControllerRead400 | BidSubmissionsControllerRead401 | BidSubmissionsControllerRead403 | BidSubmissionsControllerRead404>, BidSubmissionsControllerReadQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return bidSubmissionsControllerRead(id, params, config);
    }
  });
}

/**
 * @summary Read one bid or reply
 * {@link /api/v1/bid-submissions/:id}
 */
export function useBidSubmissionsControllerRead<TData = BidSubmissionsControllerReadQueryResponse, TQueryData = BidSubmissionsControllerReadQueryResponse, TQueryKey extends QueryKey = BidSubmissionsControllerReadQueryKey>(id: BidSubmissionsControllerReadPathParams["id"], params?: BidSubmissionsControllerReadQueryParams, options: {
  query?: Partial<QueryObserverOptions<BidSubmissionsControllerReadQueryResponse, ResponseErrorConfig<BidSubmissionsControllerRead400 | BidSubmissionsControllerRead401 | BidSubmissionsControllerRead403 | BidSubmissionsControllerRead404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? bidSubmissionsControllerReadQueryKey(id, params);
  const query = useQuery({
    ...bidSubmissionsControllerReadQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BidSubmissionsControllerRead400 | BidSubmissionsControllerRead401 | BidSubmissionsControllerRead403 | BidSubmissionsControllerRead404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}